module.exports = __webpack_public_path__ + "static/media/SalonStylo.3266e0f6.png";